import Api from "../../../../../app/axios";
import type { TarotReadingReponse } from "../models/tarot-reading-response";

export async function getTarotReadingReq({cards, language, question} : {cards : string[], question: string, language: string}): Promise<TarotReadingReponse>{
  try {
    const api = Api.getInstance()
    console.log({cards, language, question});
    
  const response = await api.post({path: `tarot-reading/new`, data: {
    cards,
    language,
    question
  }})
    console.log('getTarotReadingReq', {response});
    const { error } = response
    if(error == null) {
      return response.result
    }else {
      throw error
    }
  } catch (error) {
    console.error('ERROR ON customerAnswerReq');
    console.error({error});
    throw error;
  }
}